import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Paragraph, SemiBold, SubHeader, UnorderedList, FAQs } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(131);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-card-payment");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoCardPayment", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 7
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 7>;
      return {
        question: t(`seoCardPayment:sections.faqs.${faqIndex}.question`),
        answer: t(`seoCardPayment:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoCardPayment:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoCardPayment:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoCardPayment:header.title">{t6}</Trans>;
    t8 = t("seoCardPayment:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoCardPayment:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.registration
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoCardPayment:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paragraph: <Paragraph />
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = <Trans t={t} i18nKey="seoCardPayment:sections.1.content" components={t14} />;
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = {
      title: t13,
      content: t15
    };
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("seoCardPayment:sections.2.title");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t) {
    t19 = <Trans t={t} i18nKey="seoCardPayment:sections.2.content" components={t18} />;
    $[32] = t;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = {
      title: t17,
      content: t19
    };
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("seoCardPayment:sections.3.title");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      paragraph: <Paragraph />
    };
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t) {
    t23 = <Trans t={t} i18nKey="seoCardPayment:sections.3.content" components={t22} />;
    $[40] = t;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = [...Array(3)];
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t) {
    t25 = t24.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 3>;
      return <Trans key={i} t={t} i18nKey={`seoCardPayment:sections.3.subsections.${transIndex}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        semibold: <SemiBold />
      }} />;
    });
    $[43] = t;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t23 || $[46] !== t25) {
    t26 = <>{t23}{t25}</>;
    $[45] = t23;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== t21 || $[49] !== t26) {
    t27 = {
      title: t21,
      content: t26
    };
    $[48] = t21;
    $[49] = t26;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== t) {
    t28 = t("seoCardPayment:sections.4.title");
    $[51] = t;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t) {
    t30 = <Trans t={t} i18nKey="seoCardPayment:sections.4.content" components={t29} />;
    $[54] = t;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t28 || $[57] !== t30) {
    t31 = {
      title: t28,
      content: t30
    };
    $[56] = t28;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t) {
    t32 = t("seoCardPayment:sections.5.title");
    $[59] = t;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t) {
    t34 = <Trans t={t} i18nKey="seoCardPayment:sections.5.content" components={t33} />;
    $[62] = t;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = [...Array(8)];
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t) {
    t36 = <UnorderedList items={t35.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 8>;
      return <Trans key={i_0} t={t} i18nKey={`seoCardPayment:sections.5.list.${transIndex_0}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[65] = t;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t34 || $[68] !== t36) {
    t37 = <>{t34}{t36}</>;
    $[67] = t34;
    $[68] = t36;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t32 || $[71] !== t37) {
    t38 = {
      title: t32,
      content: t37
    };
    $[70] = t32;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t) {
    t39 = t("seoCardPayment:sections.6.title");
    $[73] = t;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t) {
    t41 = <Trans t={t} i18nKey="seoCardPayment:sections.6.content" components={t40} />;
    $[76] = t;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== t39 || $[79] !== t41) {
    t42 = {
      title: t39,
      content: t41
    };
    $[78] = t39;
    $[79] = t41;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== t) {
    t43 = t("seoCardPayment:sections.7.title");
    $[81] = t;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Paragraph />;
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      paragraph: t44,
      link1: <Link analyticsParam="seoCardPaymentHintSkipCard" testId="seoCardPaymentHintSkipCard" to={LINKS().card} />
    };
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== t) {
    t46 = <Trans t={t} i18nKey="seoCardPayment:sections.7.content" components={t45} />;
    $[85] = t;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== t43 || $[88] !== t46) {
    t47 = {
      title: t43,
      content: t46
    };
    $[87] = t43;
    $[88] = t46;
    $[89] = t47;
  } else {
    t47 = $[89];
  }
  let t48;
  if ($[90] !== t) {
    t48 = t("seoCardPayment:sections.8.title");
    $[90] = t;
    $[91] = t48;
  } else {
    t48 = $[91];
  }
  let t49;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = {
      paragraph: <Paragraph />
    };
    $[92] = t49;
  } else {
    t49 = $[92];
  }
  let t50;
  if ($[93] !== t) {
    t50 = <Trans t={t} i18nKey="seoCardPayment:sections.8.content" components={t49} />;
    $[93] = t;
    $[94] = t50;
  } else {
    t50 = $[94];
  }
  let t51;
  if ($[95] !== t48 || $[96] !== t50) {
    t51 = {
      title: t48,
      content: t50
    };
    $[95] = t48;
    $[96] = t50;
    $[97] = t51;
  } else {
    t51 = $[97];
  }
  let t52;
  if ($[98] !== t) {
    t52 = t("seoCardPayment:sections.9.title");
    $[98] = t;
    $[99] = t52;
  } else {
    t52 = $[99];
  }
  let t53;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      paragraph: <Paragraph />
    };
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  let t54;
  if ($[101] !== t) {
    t54 = <Trans t={t} i18nKey="seoCardPayment:sections.9.content" components={t53} />;
    $[101] = t;
    $[102] = t54;
  } else {
    t54 = $[102];
  }
  let t55;
  if ($[103] !== t52 || $[104] !== t54) {
    t55 = {
      title: t52,
      content: t54
    };
    $[103] = t52;
    $[104] = t54;
    $[105] = t55;
  } else {
    t55 = $[105];
  }
  let t56;
  if ($[106] !== t) {
    t56 = t("core:faqs.title");
    $[106] = t;
    $[107] = t56;
  } else {
    t56 = $[107];
  }
  let t57;
  if ($[108] !== faqsData) {
    t57 = <FAQs data={faqsData} />;
    $[108] = faqsData;
    $[109] = t57;
  } else {
    t57 = $[109];
  }
  let t58;
  if ($[110] !== t56 || $[111] !== t57) {
    t58 = {
      title: t56,
      content: t57
    };
    $[110] = t56;
    $[111] = t57;
    $[112] = t58;
  } else {
    t58 = $[112];
  }
  let t59;
  if ($[113] !== t16 || $[114] !== t20 || $[115] !== t27 || $[116] !== t31 || $[117] !== t38 || $[118] !== t42 || $[119] !== t47 || $[120] !== t51 || $[121] !== t55 || $[122] !== t58) {
    t59 = [t16, t20, t27, t31, t38, t42, t47, t51, t55, t58];
    $[113] = t16;
    $[114] = t20;
    $[115] = t27;
    $[116] = t31;
    $[117] = t38;
    $[118] = t42;
    $[119] = t47;
    $[120] = t51;
    $[121] = t55;
    $[122] = t58;
    $[123] = t59;
  } else {
    t59 = $[123];
  }
  let t60;
  if ($[124] !== menuPromoBanners || $[125] !== t12 || $[126] !== t5 || $[127] !== t59 || $[128] !== t7 || $[129] !== t9) {
    t60 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t59} />;
    $[124] = menuPromoBanners;
    $[125] = t12;
    $[126] = t5;
    $[127] = t59;
    $[128] = t7;
    $[129] = t9;
    $[130] = t60;
  } else {
    t60 = $[130];
  }
  return t60;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('platba-kartou');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoCardPayment']))
    }
  };
};